/* Cases filter — chip toggling, hide/show cards via data-attrs, count, reset */
(function () {
  var filter = document.querySelector('[data-zk-cases-filter]');
  var grid = document.querySelector('[data-zk-cases-grid]');
  var emptyEl = document.querySelector('[data-zk-cases-empty]');
  var countEl = document.querySelector('[data-zk-cases-count]');
  var nounEl = document.querySelector('[data-zk-cases-noun]');
  if (!filter || !grid) return;

  var state = { sector: 'all', color: 'all' };

  function apply() {
    var cards = grid.querySelectorAll('.zk-case-card');
    var visible = 0;
    cards.forEach(function (card) {
      var cs = card.getAttribute('data-sector') || 'all';
      var cc = card.getAttribute('data-color') || 'all';
      var match = (state.sector === 'all' || cs === state.sector) &&
                  (state.color === 'all' || cc === state.color);
      card.hidden = !match;
      if (match) visible++;
    });
    if (countEl) countEl.textContent = visible;
    if (nounEl) {
      var t = (window.theme && window.theme.t) || function (k, f) { return f; };
      nounEl.textContent = visible === 1
        ? t('zk_cases_visible_singular', 'case zichtbaar')
        : t('zk_cases_visible_plural', 'cases zichtbaar');
    }
    if (emptyEl) emptyEl.hidden = visible !== 0;
    grid.hidden = visible === 0;
  }

  filter.addEventListener('click', function (e) {
    var chip = e.target.closest('.zk-cases-filter__chip');
    if (!chip) return;
    var group = chip.parentElement.getAttribute('data-group');
    if (!group || !(group in state)) return;
    state[group] = chip.getAttribute('data-value') || 'all';
    chip.parentElement.querySelectorAll('.zk-cases-filter__chip').forEach(function (c) {
      c.classList.toggle('is-active', c === chip);
    });
    apply();
  });

  document.querySelectorAll('[data-zk-cases-reset]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.sector = 'all';
      state.color = 'all';
      filter.querySelectorAll('.zk-cases-filter__group').forEach(function (group) {
        group.querySelectorAll('.zk-cases-filter__chip').forEach(function (c, i) {
          c.classList.toggle('is-active', i === 0);
        });
      });
      apply();
    });
  });
})();
